var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatMessages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.65 17.125V2.775q0-.475.338-.813.337-.337.812-.337h13.125q.475 0 .813.337.337.338.337.813V11.9q0 .475-.337.8-.338.325-.813.325H5.75ZM7.025 18.3q-.475 0-.8-.325-.325-.325-.325-.8v-2.15h13.175v-9.15H21.2q.475 0 .813.325.337.325.337.8v15.375L18.275 18.3ZM14.8 3.9H3.925v7.825l.975-.975h9.9Zm-10.875 0V11.725Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatMessages);
export default __webpack_public_path__ + "static/media/chat_messages.4fa315eb25520d7ac55d344438a4c914.svg";
export { ForwardRef as ReactComponent };